const createScriptElement = ({ promptwatchProjectId }) => {
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('data-project-id', promptwatchProjectId);
  scriptElement.src = 'https://ingest.promptwatch.com/js/client.min.js';
  scriptElement.async = true;
  return scriptElement;
};

export default (context) => {
  const locale = context.i18n.locale;
  const domainConfig = context.$config.domainConfig;

  const promptwatchProjectId = domainConfig?.promptwatchProjectId;

  if (!promptwatchProjectId) {
    console.warn('Promptwatch: missing promptwatchProjectId for locale', locale);
    return;
  }

  const scriptElement = createScriptElement({ promptwatchProjectId });
  document.head.appendChild(scriptElement);
};
